import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbForm, AbFormMessages } from "abreact/form/AbForm";
import { AbHeaderContextProvider } from "abreact/misc/AbHeader";
import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import { AbDialogButtonBar } from "abreact/popup/AbDialogButtonBar";
import { AbPopupHeader } from "abreact/popup/AbPopupHeader";
import { DialogContext } from "abreact/popup/DialogContext";
import { observer } from "mobx-react";
import * as React from "react";
export class AbDialogContent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleMaximize", () => {
      this.props.onMaximize?.();
    });
  }
  renderDefaultButtonBar() {
    if (this.props.submitButton || this.props.okButton || this.props.cancelButton) {
      return /*#__PURE__*/React.createElement(AbDialogButtonBar, {
        okButton: this.props.okButton,
        okButtonProps: this.props.okButtonProps,
        onOk: this.props.onOk,
        submitButton: this.props.submitButton,
        submitButtonProps: this.props.submitButtonProps,
        onSubmit: this.props.onSubmit,
        cancelButton: this.props.cancelButton,
        cancelButtonProps: this.props.cancelButtonProps
      });
    }
    return null;
  }
  render() {
    const {
      submitMessage,
      validationIssues,
      ...otherFormProps
    } = this.props.formProps ?? {};
    const hasTitle = Boolean(this.props.title);
    const hasHeader = Boolean(hasTitle || this.props.icon || this.props.closeButton || this.props.maximizable);
    const header = hasHeader && /*#__PURE__*/React.createElement(AbDialogHeader, _extends({}, this.props.headerProps, {
      "data-header-lint": "header",
      style: this.props.titleBarStyle,
      icon: this.props.icon,
      title: this.props.title,
      titleID: this.props.titleID,
      maximizeButton: this.props.maximizable,
      onMaximize: this.handleMaximize,
      isMaximized: this.props.isMaximized,
      closeButton: this.props.closeButton,
      helpButton: this.props.helpButton
    }));
    const footerGuts = this.props.buttonBar === undefined ? this.renderDefaultButtonBar() : this.props.buttonBar;
    const contentClasses = "ab-dialog-content" + (footerGuts ? "" : " ab-dialog-footer-empty");
    let content = /*#__PURE__*/React.createElement("div", {
      className: contentClasses,
      ref: element => {
        if (!element) this.props.resizeObserver?.disconnect();else this.props.resizeObserver?.observe(element);
      }
    }, submitMessage && /*#__PURE__*/React.createElement(AbFormMessages, {
      submitMessage: submitMessage,
      validationIssues: validationIssues || []
    }), this.props.message && /*#__PURE__*/React.createElement("div", {
      className: "ab-dialog-message"
    }, this.props.message), this.props.children);
    const footer = footerGuts && /*#__PURE__*/React.createElement("div", {
      className: "ab-dialog-footer"
    }, /*#__PURE__*/React.createElement(AbSizeContext.Provider, {
      value: AbSize.SMALL
    }, footerGuts));
    let contentAndFooter = /*#__PURE__*/React.createElement(React.Fragment, null, content, footer);
    if (hasTitle) {
      contentAndFooter = /*#__PURE__*/React.createElement(AbHeaderContextProvider, {
        "data-header-lint": "header"
      }, contentAndFooter);
    }
    let allContent = /*#__PURE__*/React.createElement(React.Fragment, null, header, contentAndFooter);
    if (this.props.onSubmit) {
      allContent = /*#__PURE__*/React.createElement(AbForm, _extends({
        className: "ab-dialog-form",
        onSubmit: this.props.onSubmit
      }, otherFormProps), allContent);
    }
    return allContent;
  }
}
export const AbDialogHeader = observer(props => {
  const dialogContext = React.useContext(DialogContext);
  return /*#__PURE__*/React.createElement(AbPopupHeader, _extends({
    className: "ab-dialog-title-bar"
  }, props, {
    closeButtonDisabled: dialogContext?.dialogActionState?.waitingForPromise
  }));
});
//# sourceMappingURL=AbDialogContent.js.map
